import React from 'react'
import CheckoutLayout from '../../../checkout/CheckoutPage/CheckoutLayout'
import { useSalesChannel } from '../../../../context/SalesChannelContext';
import { OrderType } from '../../../../types';
import { ISalesChannel } from '../../../../services/ecommerceApi/SalesChannel/types';

export type OrderSuccessProps = {
    order: OrderType;
    loading: boolean;
    salesChannel: ISalesChannel;
}

export default function OrderSuccess({ order, loading }: OrderSuccessProps) {
    return (
        <CheckoutLayout seo={{ title: `Order ${order?.number}` }} cart={undefined} hideNav={true} showCouponCode={false} >
            <section className="py-0 md:py-10">
                {!loading && order ? (

                    <div className="flex flex-wrap -mx-3">

                        <div className="px-3 w-full mb-5 md:mb-0 md:order-2 md:w-1/3">
                            <div className="pb-[60%] bg-gray-100">

                            </div>
                        </div>

                        <div className="px-3 w-full md:order-1 md:w-2/3">

                            {order.status !== "paymentFailed" ? (
                                <>
                                    <h1 className="text-2xl">
                                        Order Success
                                    </h1>
                                    <h2 className="text-4xl">
                                        Thank you, {order.customer.firstName}
                                    </h2>
                                    <div>{order.customer.email}</div>
                                </>
                            ) : (
                                <PaymentFailedMessage />
                            )}

                            <div className="flex flex-wrap -mx-3 mt-5">

                                <div className="px-3 mb-4 md:mb-0">
                                    <h2 className="text-lg uppercase font-extrabold mb-3">Shipping Address</h2>
                                    <div className="p-5 bg-gray-100">
                                        <div>
                                            <div>
                                                {order.shippingAddress[0].firstName} {order.shippingAddress[0].lastName}
                                            </div>
                                            <div>
                                                {order.shippingAddress[0].line1}, {order.shippingAddress[0].postCode}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="px-3">
                                    <h2 className="text-lg uppercase font-extrabold mb-3">Billing Address</h2>
                                    <div className="p-5 bg-gray-100">
                                        <div>
                                            <div>
                                                {order.billingAddress.firstName} {order.billingAddress.lastName}
                                            </div>
                                            <div>
                                                {order.billingAddress.line1}, {order.billingAddress.postCode}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>



                    </div>

                ) : null}
            </section>
        </CheckoutLayout>
    )
}

function PaymentFailedMessage() {
    const salesChannel = useSalesChannel();
    return (
        <>
            <h2 className="text-4xl uppercase">
                Payment Failed
            </h2>
            <h3 className="text-2xl mt-4 mb-2">
                Having trouble placing an order?
            </h3>
            <div className='mb-3'>
                You can call us on
                {" "}
                <a className='font-bold underline' href={`tel:${salesChannel?.phone}`}>{salesChannel?.phone}</a>
                {" "}
                9AM - 5PM, Monday - Friday or drop us an email on
                {" "}
                <a className='font-bold underline' href={`mailto:${salesChannel?.email}`}>{salesChannel?.email}</a>
                {" "}
                and our Customer service team will be happy to help.
            </div>
        </>
    )
}
